<span class="inplace-input-container">
  <span class="measure" #hiddenSpanForCalc></span>
  <input
    matInput
    autocomplete="off"
    [placeholder]="placeholderText"
    [style.width]="inputWidthInlineStyle$ | async"
    [maxlength]="maxchars"
    #inlineInputElement
    (change)="emitTextChange()"
    (input)="onInput()"
    (focus)="activate()"
    (blur)="deactivate()"
    (keydown.enter)="$event.target.blur()"
    [(ngModel)]="text"
    [readonly]="readonly"
    [class.error]="hasError"
    data-test="in-place-input"
  />
  <capra-icon
    *ngIf="!hasFocus && !readonly"
    icon="icon-pencil"
    (click)="activate()"
    data-test="in-place-input-edit-icon"
  ></capra-icon>
</span>
